<div [formGroup]="form" class="detail-right-column">
   @if (showCards) {
   <ndt-card [title]="'General Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Extension Number</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extension?.number"
         [formControl]="parentFormGroup.get('number')"
         required
         id="a548a982-17d2-4bee-9fa9-e2df166087e7"
      />
      @if (parentFormGroup.get('number')?.hasError('required')) {
      <mat-error> Number Field is Required. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('pattern')) {
      <mat-error> Invalid Number Format </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
      <mat-error> Number must be between 100-99999. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
      <mat-error> Extension number already in use. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.name"
         [formControl]="parentFormGroup.get('name')"
         required
         id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
      />
      @if (parentFormGroup.get('name')?.hasError('required')) {
      <mat-error> Name Field is Required. </mat-error>
      } @if ( !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent') )
      {
      <mat-error> Name must contain characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Short Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.shortName"
         [formControl]="parentFormGroup.get('shortName')"
         id="4428b9b8-f7b4-4cf3-8ea1-832c44b55a84"
      />
      @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
      <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
      }
   </mat-form-field>
   }
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         @if (parentFormGroup.get('number')?.hasError('required')) {
         <mat-error> Number Field is Required. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('pattern')) {
         <mat-error> Invalid Number Format </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
         <mat-error> Number must be between 100-99999. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
         <mat-error> Extension number already in use. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         @if (parentFormGroup.get('name')?.hasError('required')) {
         <mat-error> Name Field is Required. </mat-error>
         } @if ( !parentFormGroup.get('name')?.hasError('required') &&
         parentFormGroup.get('name')?.hasError('noContent') ) {
         <mat-error> Name must contain characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="4428b9b8-f7b4-4cf3-8ea1-832c44b55a84"
         />
         @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
         <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
         }
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Notes'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="notesFields"></ng-container>
   </ndt-card>
   }
   <ng-template #notesFields>
      @if (isSystemUser) {
      <mat-form-field class="flex-half">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-dnd-status"
         ></textarea>
      </mat-form-field>
      }
      <mat-form-field [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser }">
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-dnd-status"
            [readonly]="isSystemUser"
         ></textarea>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ng-container>
      <ndt-card [title]="'Settings'" class="detail-card">
         <ng-container *ngTemplateOutlet="settingsFields"></ng-container>
      </ndt-card>
   </ng-container>
   } @else {
   <ng-container *ngTemplateOutlet="settingsFields"></ng-container>
   }
   <ng-template #settingsFields>
      <div class="flex-full">
         <ndt-extension-and-group-chip-input
            [extensions]="extension?.account?.extensionsConnection?.items || extensions"
            [extensionGroups]="extension?.account?.extensionGroupsConnection?.items || extensionGroups"
            formControlName="extensionsOrExtensionQueueGroupMembers"
            [extensionIdsToExclude]=""
            [extensionGroupIdsToExclude]=""
            required="true"
            [titleValue]="'Member Extensions'"
         ></ndt-extension-and-group-chip-input>
      </div>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Queue Strategy</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="queueStrategyId"
            id="queueStrategyId"
            lcsStaticSelect
            [lcsStaticSelectValue]="form.get('queueStrategyId')?.value"
            [lcsStaticSelectValue]="form.get('queueStrategyId')?.value"
            (search)="searchQueueStrategy($event)"
            (reset)="resetQueueStrategySearch()"
            [lcsSingleSelect]="queueStrategySelect"
            required
         />
         <lcs-static-select
            #queueStrategySelect
            [displayWith]="queueStrategyDisplayWith"
            [isIncludeEmptyOption]="false"
         >
            @for (queueStrategy of queueStrategies; track queueStrategy) {
            <lcs-option [value]="queueStrategy">
               {{ queueStrategy | addSpaces }}
            </lcs-option>
            }
         </lcs-static-select>
         @if (form.get('queueStrategyId')?.hasError('required')) {
         <mat-error> Queue Strategy is Required. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Wrap Up Time (seconds)</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extensionQueue?.wrapUpTime ?? 60"
            formControlName="wrapUpTime"
            id="wrapUpTime"
            required
         />
         @if (form.get('wrapUpTime')?.hasError('required')) {
         <mat-error> Wrap Up Time is Required. </mat-error>
         } @if (form.get('wrapUpTime')?.hasError('pattern')) {
         <mat-error> Wrap Up Time must be numeric </mat-error>
         } @if (form.get('wrapUpTime')?.hasError('min') || form.get('wrapUpTime')?.hasError('max')) {
         <mat-error> Wrap Up Time must be between 0-600 seconds </mat-error>
         }
      </mat-form-field>
      <div class="flex-container flex-full">
         <mat-form-field class="flex-half field-padding-right">
            <mat-label>Exit Route to Extension</mat-label>
            <input
               [lcsSingleSelect]="exitRouteToSelect"
               [accountId]="accountId"
               ndtExtensionSelect
               autocomplete="off"
               type="text"
               formControlName="exitRouteToExtension"
               id="exit-routeto-extension"
               [extensionTypesToExclude]="[7]"
            />
            <ndt-extension-select
               [isIncludeEmptyOption]="true"
               #exitRouteToSelect
               [excludedIds]="[extensionId]"
            ></ndt-extension-select>
            @if (form.get('exitRouteToExtension')?.hasError('required')) {
            <mat-error>Exit route is required. </mat-error>
            }
         </mat-form-field>
         <mat-radio-group formControlName="exitRouteVoicemailOnly" class="flex-half radio-container">
            <div class="radio-buttons" [hidden]="!isExtensionTypePhone()">
               <mat-radio-button
                  color="primary"
                  class="table-radio-button"
                  [value]="false"
                  class="phone-radio"
                  [checked]="!exiteRouteVoicemail"
                  >Phone</mat-radio-button
               >
               <mat-radio-button
                  color="primary"
                  class="table-radio-button"
                  [value]="true"
                  [checked]="exiteRouteVoicemail"
                  >Voicemail</mat-radio-button
               >
            </div>
         </mat-radio-group>
      </div>
      <div class="flex-container flex-full">
         <mat-checkbox
            class="flex-half"
            [checked]="hasPreventEmptyQueue"
            formControlName="hasPreventEmptyQueue"
            id="hasPreventEmptyQueue"
            (change)="onPreventEmptyQueueChange($event)"
            >Prevent Empty Queue</mat-checkbox
         >
         <mat-form-field [hidden]="!hasPreventEmptyQueue" class="flex-half field-padding-right">
            <mat-label>Queue Empty Exit Route</mat-label>
            <input
               class="empty-option-placeholder"
               [lcsSingleSelect]="emptyexitRouteToSelect"
               [accountId]="accountId"
               ndtExtensionSelect
               autocomplete="off"
               type="text"
               formControlName="queueEmptyExitRouteToExtension"
               [required]="hasPreventEmptyQueue"
               id="empty-exit-routeto-extension"
               [extensionTypesToExclude]="[7]"
            />
            <ndt-extension-select
               [isIncludeEmptyOption]="false"
               #emptyexitRouteToSelect
               [nullActionsToInclude]="nullActions"
               [excludedIds]="[extensionId]"
            ></ndt-extension-select>
            @if (form.get('queueEmptyExitRouteToExtension')?.hasError('queueEmptyExitRequired')) {
            <mat-error> Queue Empty Exit Route is Required. </mat-error>
            }
         </mat-form-field>
      </div>
      @if (accountId) {
      <mat-form-field class="flex-half">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select> </mat-form-field
      >}
      <mat-form-field class="flex-half">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            isIncludeEmptyOption="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Hold Music'" class="detail-card-half">
      @if (showCards) {
      <mat-checkbox
         header-action
         class="card-header-checkbox mat-contrast"
         [checked]="holdMusicOptionValue === 'default'"
         [disabled]="!canEdit"
         id="isCustomHoldMusic"
         (change)="onHoldMusicOptionChange($event)"
         >Use Account Default</mat-checkbox
      >
      }
      <ng-container *ngTemplateOutlet="holdMusicFields"> </ng-container>
   </ndt-card>
   } @else { @if (!showCards) {
   <mat-checkbox
      class="flex-full"
      [checked]="holdMusicOptionValue === 'default'"
      [disabled]="!canEdit"
      id="isCustomHoldMusic"
      (change)="onHoldMusicOptionChange($event)"
      >Use Account Default Hold Music</mat-checkbox
   >
   }
   <div class="flex-full flex-container">
      <mat-form-field class="flex-half-drop field-padding-right with-half-button">
         <mat-label>Hold Music Prompt</mat-label>
         <input
            [lcsSingleSelect]="mohPromptSelect"
            [accountId]="accountId"
            [promptTypesToInclude]="[3]"
            ndtPromptSelect
            type="text"
            formControlName="holdMusicPrompt"
            id="holdMusicPrompt"
            required
         />
         <ndt-prompt-select
            #mohPromptSelect
            [isIncludeEmptyOption]="false"
            [promptIdsToInclude]="promptsToInclude"
         ></ndt-prompt-select>
         @if (form.get('holdMusicPrompt')?.hasError('required')) {
         <mat-error> Hold Music Prompt is Required. </mat-error>
         }
      </mat-form-field>
      <div class="flex-half-button">
         <button
            mat-mini-fab
            color="primary"
            type="button"
            (click)="dispatchUploadMohFile()"
            class="prompt-button"
            [disabled]="!canEdit || holdMusicOptionValue === 'default'"
         >
            <mat-icon>add</mat-icon>
         </button>
      </div>
   </div>
   }
   <ng-template #holdMusicFields>
      @if (!showCards) {
      <mat-checkbox
         class="flex-full"
         [checked]="holdMusicOptionValue === 'default'"
         [disabled]="!canEdit"
         id="isCustomHoldMusic"
         (change)="onHoldMusicOptionChange($event)"
         >Use Account Default Hold Music</mat-checkbox
      >
      }
      <div class="flex-full flex-container">
         <mat-form-field class="flex-half-drop field-padding-right with-half-button">
            <mat-label>Hold Music Prompt</mat-label>
            <input
               [lcsSingleSelect]="mohPromptSelect"
               [accountId]="accountId"
               [promptTypesToInclude]="[3]"
               ndtPromptSelect
               type="text"
               formControlName="holdMusicPrompt"
               id="holdMusicPrompt"
               required
            />
            <ndt-prompt-select
               #mohPromptSelect
               [isIncludeEmptyOption]="false"
               [promptIdsToInclude]="promptsToInclude"
            ></ndt-prompt-select>
            @if (form.get('holdMusicPrompt')?.hasError('required')) {
            <mat-error> Hold Music Prompt is Required. </mat-error>
            }
         </mat-form-field>
         <div class="flex-half-button">
            <button
               mat-mini-fab
               color="primary"
               type="button"
               (click)="dispatchUploadMohFile()"
               class="prompt-button"
               [disabled]="!canEdit || holdMusicOptionValue === 'default'"
            >
               <mat-icon>add</mat-icon>
            </button>
         </div>
      </div>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Callback Settings'" class="detail-card-half">
      @if (showCards) {
      <mat-checkbox
         header-action
         class="card-header-checkbox mat-contrast"
         [checked]="isCallBackAvailable"
         formControlName="isCallBackAvailable"
         id="isCallBackAvailable"
         (change)="onCallBackAvailableOptionChange($event)"
         >Callback Enabled</mat-checkbox
      >
      }
      <ng-container *ngTemplateOutlet="callbackSettingsFields"></ng-container>
   </ndt-card>
   } @else { @if (!showCards) {
   <mat-checkbox
      class="flex-full"
      [checked]="isCallBackAvailable"
      formControlName="isCallBackAvailable"
      id="isCallBackAvailable"
      (change)="onCallBackAvailableOptionChange($event)"
      >Callback Enabled</mat-checkbox
   >}
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Type of Callback</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         formControlName="typeOfCallback"
         id="typeOfCallback"
         lcsStaticSelect
         [lcsStaticSelectValue]="form.get('typeOfCallback')?.value"
         (search)="searchCallbackType($event)"
         (reset)="resetCallbackTypeSearch()"
         [lcsSingleSelect]="callbackTypeSelect"
         [required]="form.get('isCallBackAvailable')?.value"
      />
      <lcs-static-select #callbackTypeSelect [displayWith]="callbackTypeDisplayWith" [isIncludeEmptyOption]="false">
         @for (callbackType of callbackTypes; track callbackType) {
         <lcs-option [value]="callbackType">
            {{ callbackType | addSpaces }}
         </lcs-option>
         }
      </lcs-static-select>
      @if (form.get('holdMusicPrompt')?.hasError('required')) {
      <mat-error> Hold Music Prompt is Required. </mat-error>
      }
   </mat-form-field>
   <div class="flex-container flex-half">
      <mat-form-field class="flex-half-drop field-padding-right with-half-button">
         <mat-label>Callback Prompt</mat-label>
         <input
            [lcsSingleSelect]="callbackPromptSelect"
            [accountId]="accountId"
            [promptTypesToInclude]="[5]"
            ndtPromptSelect
            type="text"
            formControlName="callbackPrompt"
            id="callbackPrompt"
         />
         <ndt-prompt-select
            #callbackPromptSelect
            [isIncludeEmptyOption]="true"
            [promptIdsToInclude]="callbackPromptsToInclude"
         ></ndt-prompt-select>
      </mat-form-field>
      <div class="flex-half-button">
         <button
            [disabled]="!isCallBackAvailable || !canEdit"
            mat-mini-fab
            color="primary"
            type="button"
            (click)="dispatchUploadCallbackFile()"
            class="prompt-button"
         >
            <mat-icon>add</mat-icon>
         </button>
      </div>
   </div>
   @if (form.get('isCallBackAvailable')?.value && form.get('typeOfCallback')?.value === callBackTypes.CallersInTheQueue)
   {
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Minimum Callers Required for Callback</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extensionQueue?.callersNeededForCallback ?? 3"
         formControlName="callersNeededForCallback"
         id="callersNeededForCallback"
         [required]="form.get('isCallBackAvailable')?.value"
      />
      @if (form.get('callersNeededForCallback')?.hasError('required')) {
      <mat-error> Minimum Callers is Required. </mat-error>
      } @if(form.get('callersNeededForCallback')?.hasError('pattern')){
      <mat-error> Minimum Callers must be numeric </mat-error>
      } @if(form.get('callersNeededForCallback')?.hasError('min') ||
      form.get('callersNeededForCallback')?.hasError('max')) {
      <mat-error> Minimum Callers must be between 3-30. </mat-error>
      }
   </mat-form-field>
   } @if(form.get('isCallBackAvailable')?.value && form.get('typeOfCallback')?.value === callBackTypes.ExpectedHoldTime
   ){
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Hold Time Needed for Callback</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extensionQueue?.holdTimeNeededForCallback ?? 5"
         formControlName="holdTimeNeededForCallback"
         id="holdTimeNeededForCallback"
         [required]="form.get('isCallBackAvailable')?.value"
      />
      @if(form.get('holdTimeNeededForCallback')?.hasError('required')){
      <mat-error> Hold Time is Required. </mat-error>
      } @if(form.get('holdTimeNeededForCallback')?.hasError('pattern')) {
      <mat-error> Hold Time must be numeric </mat-error>
      } @if( form.get('holdTimeNeededForCallback')?.hasError('min') ||
      form.get('holdTimeNeededForCallback')?.hasError('max') ) {
      <mat-error> Hold time needed for callback must be between 5-60 minutes. </mat-error>
      }
   </mat-form-field>
   } }
   <ng-template #callbackSettingsFields
      >@if (!showCards) {
      <mat-checkbox
         class="flex-full"
         [checked]="isCallBackAvailable"
         formControlName="isCallBackAvailable"
         id="isCallBackAvailable"
         (change)="onCallBackAvailableOptionChange($event)"
         >Callback Enabled</mat-checkbox
      >}
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Type of Callback</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="typeOfCallback"
            id="typeOfCallback"
            lcsStaticSelect
            [lcsStaticSelectValue]="form.get('typeOfCallback')?.value"
            (search)="searchCallbackType($event)"
            (reset)="resetCallbackTypeSearch()"
            [lcsSingleSelect]="callbackTypeSelect"
            [required]="form.get('isCallBackAvailable')?.value"
         />
         <lcs-static-select #callbackTypeSelect [displayWith]="callbackTypeDisplayWith" [isIncludeEmptyOption]="false">
            @for (callbackType of callbackTypes; track callbackType) {
            <lcs-option [value]="callbackType">
               {{ callbackType | addSpaces }}
            </lcs-option>
            }
         </lcs-static-select>
         @if (form.get('holdMusicPrompt')?.hasError('required')) {
         <mat-error> Hold Music Prompt is Required. </mat-error>
         }
      </mat-form-field>
      <div class="flex-container flex-half">
         <mat-form-field class="flex-half-drop field-padding-right with-half-button">
            <mat-label>Callback Prompt</mat-label>
            <input
               [lcsSingleSelect]="callbackPromptSelect"
               [accountId]="accountId"
               [promptTypesToInclude]="[5]"
               ndtPromptSelect
               type="text"
               formControlName="callbackPrompt"
               id="callbackPrompt"
            />
            <ndt-prompt-select
               #callbackPromptSelect
               [isIncludeEmptyOption]="true"
               [promptIdsToInclude]="callbackPromptsToInclude"
            ></ndt-prompt-select>
         </mat-form-field>
         <div class="flex-half-button">
            <button
               [disabled]="!isCallBackAvailable || !canEdit"
               mat-mini-fab
               color="primary"
               type="button"
               (click)="dispatchUploadCallbackFile()"
               class="prompt-button"
            >
               <mat-icon>add</mat-icon>
            </button>
         </div>
      </div>
      @if (form.get('isCallBackAvailable')?.value && form.get('typeOfCallback')?.value ===
      callBackTypes.CallersInTheQueue) {
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Minimum Callers Required for Callback</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extensionQueue?.callersNeededForCallback ?? 3"
            formControlName="callersNeededForCallback"
            id="callersNeededForCallback"
            [required]="form.get('isCallBackAvailable')?.value"
         />
         @if (form.get('callersNeededForCallback')?.hasError('required')) {
         <mat-error> Minimum Callers is Required. </mat-error>
         } @if(form.get('callersNeededForCallback')?.hasError('pattern')){
         <mat-error> Minimum Callers must be numeric </mat-error>
         } @if(form.get('callersNeededForCallback')?.hasError('min') ||
         form.get('callersNeededForCallback')?.hasError('max')) {
         <mat-error> Minimum Callers must be between 3-30. </mat-error>
         }
      </mat-form-field>
      } @if(form.get('isCallBackAvailable')?.value && form.get('typeOfCallback')?.value ===
      callBackTypes.ExpectedHoldTime ){
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Hold Time Needed for Callback</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extensionQueue?.holdTimeNeededForCallback ?? 5"
            formControlName="holdTimeNeededForCallback"
            id="holdTimeNeededForCallback"
            [required]="form.get('isCallBackAvailable')?.value"
         />
         @if(form.get('holdTimeNeededForCallback')?.hasError('required')){
         <mat-error> Hold Time is Required. </mat-error>
         } @if(form.get('holdTimeNeededForCallback')?.hasError('pattern')) {
         <mat-error> Hold Time must be numeric </mat-error>
         } @if( form.get('holdTimeNeededForCallback')?.hasError('min') ||
         form.get('holdTimeNeededForCallback')?.hasError('max') ) {
         <mat-error> Hold time needed for callback must be between 5-60 minutes. </mat-error>
         }
      </mat-form-field>
      }
   </ng-template>
</div>
